module.exports = __webpack_public_path__ + "static/media/mom_daughter_faces.5353b313.svg";